<template>
  <div>
    <div class="card" ref="div2">
      <Toolbar class="p-mb-4">
        <template slot="left">
          <div class="switch">
            <h5 class="pad-switch-right">YTD</h5>
            <InputSwitch v-model="allMonths"/>
            <h5 class="pad-switch-left">All Months</h5>
          </div>
        </template>
        <template slot="right">
          <div class="switch">
            <h5 class="pad-switch-right">Full Stats</h5>
            <InputSwitch v-model="comparison" class="pas-switch"/>
            <h5 class="pad-switch-left">Previous Years</h5>
          </div>
        </template>
      </Toolbar>

      <DataTable 
        :value="sales" 
        :expandedRows.sync="expandedRows" 
        class="p-datatable-gridlines" 
        :loading="requesting" 
        @row-expand="onRowExpand" 
        style="overflow: scroll;"
      >
        <ColumnGroup type="header" v-if="comparison">
            <Row>
              <Column header="" :rowspan="1" headerStyle="width: 50px" />
              <Column header=""  headerStyle="width: 8.5em"/>
              <Column :header="minus3Year" :colspan="2" headerStyle="width: 15em; text-align: center;"/>
              <Column :header="minus2Year" :colspan="2" headerStyle="width: 15em; text-align: center;"/>
              <Column :header="prevYear" :colspan="2" headerStyle="width: 15em; text-align: center;"/>
              <Column :header="currYear" :colspan="3" headerStyle="width: 25em; text-align: center;"/>
            </Row> 
            <Row>
                <Column header="" :rowspan="1" headerStyle="width: 50px" />
                <Column>
                  <template #header v-if="comparison">
                    <span>Branch Code</span>
                    <br />
                    <span>(TAS Code)</span>
                  </template>
                </Column>
                <Column header="Sales" :sortable="true" field="minus3YearSales" headerStyle="width: 10em"/>
                <Column :header="'vs '+currYear+' Sales %'" field="percChangeMinus3"  headerStyle="width: 5em"/>
                <Column header="Sales" :sortable="true" field="minus2YearSales" headerStyle="width: 10em"/>
                <Column :header="'vs '+currYear+' Sales %'" field="percChangeMinus2"  headerStyle="width: 5em"/>
                <Column header="Sales" :sortable="true" field="prevYearSales" headerStyle="width: 10em"/>
                <Column :header="'vs '+currYear+' Sales %'" field="percChangePrev"  headerStyle="width: 5em"/>
                <Column header="Sales" :sortable="true" field="currYearSales" headerStyle="width: 10em"/>
                <Column header="Forecast" :sortable="true" field="currYearForecast" headerStyle="width: 10em"/>
                <Column :header="'Forecast vs '+currYear+' Sales %'" :colspan="1"  headerStyle="width: 5em"/>
            </Row>
        </ColumnGroup>
          <ColumnGroup type="header" v-else>
            <Row>
                <Column header="" :rowspan="1" headerStyle="width: 50px" />
                <Column header="" :rowspan="2"  headerStyle="width: 7em">
                  <template #header v-if="!comparison">
                    <span>Branch Code</span>
                    <br />
                    <span>(TAS Code)</span>
                  </template>
                </Column>
                <Column header="Forecast" :colspan="1"   headerStyle="width: 10em; text-align: center;"/>
                <Column header="Sales" :colspan="2"   headerStyle="width: 20em; text-align: center;"/>
                <Column header="Comparisons" :colspan="2"  headerStyle="width: 16em; text-align: center;"/>
                <Column :header="'Quotations '+currYear " :colspan="3"  headerStyle="width: 23.5em; text-align: center;"/>
            </Row>
            <Row>
                <Column header="" field="first"/>
                <Column :header="currYear" :sortable="true" field="currYearForecast"/>
                <Column :header="prevYear" :sortable="true" field="prevYearSales"/>
                <Column :header="currYear" :sortable="true" field="currYearSales"/>
                <Column header="Sales vs Prev Year %" :sortable="false" field="percChangePrev"/>
                <Column header="Sales vs Forecast %" :sortable="false" field="percChangeForecast"/>
                <Column header="Won quotes" :sortable="false" field="wonQuotes"/>
                <Column header="Lost quotes" :sortable="false" field="lostQuotes"/>
                <Column header="Created Quotes" :sortable="false" field="createdQuotes"/>
            </Row>
        </ColumnGroup>
        <Column :expander="true"/>

        <Column field="branch.branchCode">
            <template #body="slotProps">
              <div v-if="slotProps.data.branch">
                <strong>{{ slotProps.data.branch.branchCode }}</strong>
                <br />
                <span v-if="slotProps.data.branch.tasCode">({{slotProps.data.branch.tasCode}})</span>
              </div>
            </template>
        </Column>
        <template v-if="comparison">
          <Column field="minus3YearSales">
          <template #body="slotProps"> 
                <strong>£{{ formatString(slotProps.data.minus3YearSales) }}</strong>
            </template>
          </Column>
          <Column field="percChangeMinus3">
              <template #body="slotProps"> 
                  <strong v-if="!slotProps.data.minus2YearSales ||  slotProps.data.minus3YearSales === 0 || Number.isNaN(slotProps.data.minus3YearSales)" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) }}%</strong>
              </template>
          </Column>
          <Column field="minus2YearSales">
          <template #body="slotProps"> 
                <strong>£{{ formatString(slotProps.data.minus2YearSales) }}</strong>
            </template>
          </Column>
          <Column field="percChangeMinus2">
              <template #body="slotProps">
                  <strong v-if="!slotProps.data.minus2YearSales || slotProps.data.minus2YearSales === 0 || Number.isNaN(slotProps.data.minus2YearSales)" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) }}%</strong>
              </template>
          </Column>
          <Column field="prevYearSales">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.prevYearSales) }}</strong>
              </template>
          </Column>
           <Column field="percChangePrev">
              <template #body="slotProps">
                  <strong v-if="slotProps.data.prevYearSales === 0 || Number.isNaN(slotProps.data.prevYearSales)" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
              </template>
          </Column>
           <Column field="currYearSales">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.currYearSales) }}</strong>
              </template>
          </Column>
          <Column field="currYearForecast">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.currYearForecast) }}</strong>
              </template>
          </Column>
          <Column field="percChangeForecast">
              <template #body="slotProps">
                  <strong v-if="slotProps.data.currYearForecast === 0" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
              </template>
          </Column>
        </template>
        <template v-else>
          <Column field="currYearForecast">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.currYearForecast) }}</strong>
              </template>
          </Column>
          <Column field="prevYearSales">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.prevYearSales) }}</strong>
              </template>
          </Column>
          <Column field="currYearSales">
              <template #body="slotProps">
                  <strong>£{{ formatString(slotProps.data.currYearSales) }}</strong>
              </template>
          </Column>
          <Column field="percChangePrev">
              <template #body="slotProps">
                  <strong v-if="slotProps.data.prevYearSales === 0" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
              </template>
          </Column>
          <Column field="percChangeForecast">
              <template #body="slotProps">
                  <strong v-if="slotProps.data.currYearForecast === 0" style="color: green">0%</strong>
                  <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                  <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
              </template>
          </Column>
          <Column field="wonQuotes">
              <template #body="slotProps">
                  <strong>{{ formatString(slotProps.data.wonQuotes) }}</strong>
              </template>
          </Column>
          <Column field="lostQuotes">
              <template #body="slotProps">
                  <strong>{{ formatString(slotProps.data.lostQuotes) }}</strong>
              </template>
          </Column>
          <Column field="createdQuotes">
              <template #body="slotProps">
                  <strong>{{ formatString(slotProps.data.createdQuotes) }}</strong>
              </template>
          </Column>
        </template>
        
        <template #expansion="slotProps" v-if="comparison">
            <div class="orders-subtable">
                <DataTable :value="slotProps.data.months" class="p-datatable-gridlines">
                    <Column field="first">
                    </Column>
                     <Column field="month">
                      <template #body="slotProps">
                          <strong>Month {{ slotProps.data.rowMonth }}</strong>
                      </template>
                    </Column>
                    <Column field="minus3YearSales">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.minus3YearSales) }}</strong>
                        </template>
                    </Column>
                    <Column field="percChangeMinus3">
                        <template #body="slotProps">
                            <strong v-if="!slotProps.data.minus3YearSales || slotProps.data.minus3YearSales === 0 || Number.isNaN(slotProps.data.minus3YearSales)" style="color: green">0%</strong>
                            <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus3YearSales) / slotProps.data.minus3YearSales * 100) }}%</strong>
                        </template>
                    </Column>
                    <Column field="minus2YearSales">
                    <template #body="slotProps"> 
                          <strong>£{{ formatString(slotProps.data.minus2YearSales) }}</strong>
                      </template>
                    </Column>
                    <Column field="percChangeMinus2">
                        <template #body="slotProps">
                            <strong v-if="!slotProps.data.minus2YearSales || slotProps.data.minus2YearSales === 0 || Number.isNaN(slotProps.data.minus2YearSales)" style="color: green">0%</strong>
                            <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.minus2YearSales) / slotProps.data.minus2YearSales * 100) }}%</strong>
                        </template>
                    </Column>
                    <Column field="prevYearSales">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.prevYearSales) }}</strong>
                        </template>
                    </Column>
                    <Column field="percChangePrev">
                        <template #body="slotProps">
                            <strong v-if="slotProps.data.prevYearSales === 0" style="color: green">0%</strong>
                            <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.prevYearSales) / slotProps.data.prevYearSales * 100) }}%</strong>
                        </template>
                    </Column>
                    <Column field="currYearSales">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.currYearSales) }}</strong>
                        </template>
                    </Column>
                    <Column field="currYearForecast">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.currYearForecast) }}</strong>
                        </template>
                    </Column>
                    <Column field="percChangeForecast">
                        <template #body="slotProps">
                            <strong v-if="slotProps.data.currYearForecast === 0" style="color: green">0%</strong>
                            <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </template>
         <template #expansion="slotProps" v-else>
            <div class="orders-subtable">
                <DataTable :value="slotProps.data.months" class="p-datatable-gridlines">
                    <Column field="first">
                    </Column>
                    <Column field="month">
                      <template #body="slotProps">
                          <strong>Month {{ slotProps.data.rowMonth }}</strong>
                      </template>
                    </Column>
                    <Column field="currYearForecast">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.currYearForecast) }}</strong>
                        </template>
                    </Column>
                    <Column field="prevYearSales">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.prevYearSales) }}</strong>
                        </template>
                    </Column>
                    <Column field="currYearSales">
                        <template #body="slotProps">
                            <strong>£{{ formatString(slotProps.data.currYearSales) }}</strong>
                        </template>
                    </Column>
                    <Column field="percChangePrev">
                        <template #body="slotProps">
                            <strong v-if="Math.round(slotProps.data.percChangePrev) >= 0" style="color: green">{{ Math.round(slotProps.data.percChangePrev) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round(slotProps.data.percChangePrev) }}%</strong>
                        </template>
                    </Column>
                    <Column field="percChangeForecast">
                        <template #body="slotProps">
                            <strong v-if="slotProps.data.currYearForecast === 0" style="color: green">0%</strong>
                            <strong v-else-if="Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) >= 0" style="color: green">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                            <strong v-else style="color: red">{{ Math.round((slotProps.data.currYearSales - slotProps.data.currYearForecast) / slotProps.data.currYearForecast * 100) }}%</strong>
                        </template>
                    </Column>
                    <Column field="wonQuotes">
                        <template #body="slotProps">
                            <strong>{{ formatString(slotProps.data.wonQuotes) }}</strong>
                        </template>
                    </Column>
                    <Column field="lostQuotes">
                        <template #body="slotProps">
                            <strong>{{ formatString(slotProps.data.lostQuotes) }}</strong>
                        </template>
                    </Column>
                    <Column field="createdQuotes">
                        <template #body="slotProps">
                            <strong>{{ formatString(slotProps.data.createdQuotes) }}</strong>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </template>
        <ColumnGroup type="footer" v-if="comparison">
            <Row>
                <Column footer="Totals (All branches):" :colspan="2" footerStyle="text-align:right"/>
                <Column :footer="'£' + formatString(minus3YearTotalSales)" />
                <Column 
                  :footer="minus3YearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - minus3YearTotalSales) / minus3YearTotalSales * 100)).toString() + '%' : '0%'" 
                  :footerStyle="minus3YearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - minus3YearTotalSales) / minus3YearTotalSales * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
                <Column :footer="'£' + formatString(minus2YearTotalSales)" />
                <Column 
                  :footer="minus2YearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - minus2YearTotalSales) / minus2YearTotalSales * 100)).toString() + '%' : '0%'" 
                  :footerStyle="minus2YearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - minus2YearTotalSales) / minus2YearTotalSales * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
                <Column :footer="'£' + formatString(prevYearTotalSales)" />
                <Column 
                  :footer="prevYearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - prevYearTotalSales) / prevYearTotalSales * 100)).toString() + '%' : '0%'" 
                  :footerStyle="prevYearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - prevYearTotalSales) / prevYearTotalSales * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
                <Column :footer="'£' + formatString(currYearTotalSales)" />
                <Column :footer="'£' + formatString(currYearTotalForecast)" />
                <Column 
                  :footer="currYearTotalForecast > 0 ? Math.round(formatString((currYearTotalSales - currYearTotalForecast) / currYearTotalForecast * 100)).toString() + '%' : '0%'" 
                  :footerStyle="currYearTotalForecast > 0 ? Math.round(formatString((currYearTotalSales - currYearTotalForecast) / currYearTotalForecast * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
            </Row>
        </ColumnGroup>
        <ColumnGroup type="footer" v-else>
            <Row>
                <Column footer="Totals (All branches):" :colspan="2" footerStyle="text-align:right"/>
                <Column :footer="'£' + formatString(currYearTotalForecast)" />
                <Column :footer="'£' + formatString(prevYearTotalSales)" />
                <Column :footer="'£' + formatString(currYearTotalSales)" />
                <Column 
                  :footer="prevYearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - prevYearTotalSales) / prevYearTotalSales * 100)).toString() + '%' : '0%'" 
                  :footerStyle="prevYearTotalSales > 0 ? Math.round(formatString((currYearTotalSales - prevYearTotalSales) / prevYearTotalSales * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
                <Column 
                  :footer="currYearTotalForecast > 0 ? Math.round(formatString((currYearTotalSales - currYearTotalForecast) / currYearTotalForecast * 100)).toString() + '%' : '0%'" 
                  :footerStyle="currYearTotalForecast > 0 ? Math.round(formatString((currYearTotalSales - currYearTotalForecast) / currYearTotalForecast * 100)) >= 0 ? 'color: green' : 'color: red' : 'color: green'"/>
                <Column :footer="formatString(totalWons)" />
                <Column :footer="formatString(totalLosts)" />
                <Column :footer="formatString(totalCreated)" /> 
            </Row>
        </ColumnGroup>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { formatAmount } from '@/utils/money'
import CustomerService from "@/service/CustomerService";
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Row from 'primevue/row';     //optional for column grouping

export default {
    components: {
      ColumnGroup,
      Row
    },
    created() {
      this.getCustomerStats()
    },
    props: ["customer"],
    data() {
      return {
        customerService: new CustomerService(),
        requesting: false,
        data: [],
        sales: [],
        expandedRows: [],
        prevYear: null,
        currYear: null,
        minus2Year: null,
        minus3Year: null,
        prevYearTotalForecast: 0,
        currYearTotalForecast: 0,
        minus2YearTotalSales: 0,
        minus3YearTotalSales: 0,
        prevYearTotalSales: 0,
        currYearTotalSales: 0,
        totalPerCChange: 0,
        totalPerCChangeMinus2Year: 0,
        totalPerCChangeMinus3Year: 0,
        totalPerCChangeForecast: 0,
        totalWons: 0,
        totalLosts: 0,
        totalCreated: 0,
        allMonths: true,
        comparison: false
      }
    },
    watch: {
      expandedRows() {
        setTimeout(() => {
          this.setInnerTableColumnsWidth()
        }, 10)
      },
      allMonths() {
        this.setupDataToShow()
         setTimeout(() => {
          this.setInnerTableColumnsWidth()
        }, 10)
      },
      comparison() {
         setTimeout(() => {
          this.setInnerTableColumnsWidth()
        }, 10)
      },
      getAppWindowWidth() {
        this.setInnerTableColumnsWidth();
      }
    },
    computed: {
      getAppWindowWidth() {
        return this.$store.getters.getAppWindowWidth;
      }
    },
    methods: {
      setInnerTableColumnsWidth() {
        var table = document.getElementsByClassName('p-datatable-tbody'),
          duplicateTable = [...table]
          duplicateTable.shift()
          duplicateTable.shift()
          
        if (table.length > 2) {

          // loop for tables
          var loop = 0
          while(loop < table[1].children.length) {
            
            let outerLoop = Math.floor(loop/2)
            
            if (
              table[1].children[loop]
              && table[1].children[loop].tagName === 'TR'
              && table[1].children[loop + 1]
              && table[1].children[loop + 1].tagName === 'TR'
              && table[1].children[loop + 1].className === 'p-datatable-row-expansion'
              && duplicateTable[outerLoop]
              && duplicateTable[outerLoop].children
              && duplicateTable[outerLoop].children[0]
              && duplicateTable[outerLoop].children[0].children.length === table[1].children[loop].children.length
            ) {

              let expandedTableStyles = window.getComputedStyle(duplicateTable[outerLoop].parentNode.parentNode.parentNode.parentNode.parentNode), paddingLeft = expandedTableStyles.getPropertyValue('padding-left')

              if (paddingLeft && paddingLeft.length > 2) {
                paddingLeft = parseFloat(paddingLeft.substr(0, paddingLeft.length - 2))
              }

              // loop for table columns
              for (let i = 0; i < table[1].children[loop].children.length; i++) {
                

                let location1 = table[1].children[loop].children[i].getBoundingClientRect()

                // loop for table rows
                for (let j = 0; j < duplicateTable[outerLoop].children.length; j ++) {
                  if (i === 0 || i ===  table[1].children[loop].children.length - 1) {
                    duplicateTable[outerLoop].children[j].children[i].style.width = `${location1.width - paddingLeft}px`
                  }
                  else {
                    duplicateTable[outerLoop].children[j].children[i].style.width = `${location1.width}px`
                  }
                  
                  duplicateTable[outerLoop].children[j].style.display = 'flex';
                  duplicateTable[outerLoop].children[j].children[i].style.flex = 'none';
                }

              }
              loop += 2

            } else {
              loop += 1
            }

          }
        }

      },
      setupDataToShow() {
        // let data1 = data.replace(/\bNaN\b/g, null),
        // data2 = data1.replace(/\bInfinity\b/g, null),
        // json = JSON.parse(data2)
        this.sales = []
        this.prevYearTotalForecast = 0
        this.currYearTotalForecast = 0
        this.prevYearTotalSales = 0
        this.currYearTotalSales = 0
        this.minus2YearTotalSales = 0
        this.minus3YearTotalSales = 0
        this.totalPerCChange = 0
        this.totalPerCChangeForecast = 0
        this.totalPerCChangeMinus2Year = 0
        this.totalPerCChangeMinus3Year = 0
        this.totalWons = 0
        this.totalLosts = 0
        this.totalCreated = 0

        let json = this.data, uptoMonths = 12

        if (!this.allMonths) {
          uptoMonths = new Date().getMonth()
        }

        let row = {
          branch: {},
          prevYearForecast: 0,
          currYearForecast: 0,
          minus2YearSales: 0,
          minus3YearSales: 0,
          prevYearSales: 0,
          currYearSales: 0,
          percChangePrev : 0,
          percChangeForecast: 0,
          percChangeMinus2: 0,
          percChangeMinus3: 0,
          wonQuotes : 0,
          lostQuotes : 0,
          createdQuotes: 0,
          months: []
        }

        for (let i in json) {
          if (json[i].rowMonth <= uptoMonths) {
            
            if (
                (
                    this.prevYear && json[i].prevYear && json[i].prevYear < this.prevYear
                ) ||
                !this.prevYear
            ) {
                this.prevYear = json[i].prevYear
            }
            
            if (
                (
                    this.currYear && json[i].currYear && json[i].currYear > this.currYear
                ) ||
                !this.currYear
            ) {
                this.currYear = json[i].currYear
            }

             if (
                (
                    this.minus2Year && json[i].minus2Year && json[i].minus2Year < this.minus2Year
                ) ||
                !this.minus2Year
            ) {
                this.minus2Year = json[i].minus2Year
            }

             if (
                (
                    this.minus3Year && json[i].minus3Year && json[i].minus3Year < this.minus3Year
                ) ||
                !this.minus3Year
            ) {
                this.minus3Year = json[i].minus3Year
            }

            row.prevYearForecast += json[i].prevYearForecast
            row.prevYearSales += json[i].prevYearSales
            row.minus2YearSales += json[i].minus2YearSales
            row.minus3YearSales  += json[i].minus3YearSales
            row.currYearForecast += json[i].currYearForecast
            row.currYearSales += json[i].currYearSales
            row.percChangePrev += json[i].percChangePrev
            row.percChangeMinus2 += json[i].percChangeMinus2
            row.percChangeMinus3 += json[i].percChangeMinus3
            row.percChangeForecast += json[i].percChangeForecast
            row.wonQuotes += json[i].wonQuotes
            row.lostQuotes += json[i].lostQuotes
            row.createdQuotes += json[i].createdQuotes
            row.months.push(json[i]) 
            
            this.prevYearTotalForecast += json[i].prevYearForecast
            this.currYearTotalForecast += json[i].currYearForecast
            this.minus2YearTotalSales += json[i].minus2YearSales
            this.minus3YearTotalSales += json[i].minus3YearSales
            this.prevYearTotalSales += json[i].prevYearSales
            this.currYearTotalSales += json[i].currYearSales
            this.totalPerCChange += json[i].percChangePrev
            this.totalPerCChangeMinus2Year += json[i].percChangeMinus2
            this.totalPerCChangeMinus3Year += json[i].percChangeMinus3
            this.totalPerCChangeForecast += json[i].percChangeForecast
            this.totalWons += json[i].wonQuotes
            this.totalLosts += json[i].lostQuotes
            this.totalCreated += json[i].createdQuotes

            if (json[i].rowMonth == 1) {
              
                row.branch = {
                    branchId: json[i].branchId,
                    branchName: json[i].branchName,
                    branchCode: json[i].branchCode,
                    tasCode: json[i].tasCode,
                }
            }
            if (json[i].rowMonth == uptoMonths) {
                this.sales.push(row)

                row = {
                  branch: {},
                  prevYearForecast: 0,
                  currYearForecast: 0,
                  minus2YearSales: 0,
                  minus3YearSales: 0,
                  prevYearSales: 0,
                  currYearSales: 0,
                  percChangePrev : 0,
                  percChangeForecast: 0,
                  percChangeMinus2: 0,
                  percChangeMinus3: 0,
                  wonQuotes : 0,
                  lostQuotes : 0,
                  createdQuotes: 0,
                  months: []
                }
            }
          }
        }
      },
        onRowExpand(event) {
          setTimeout(() => {
            let headers = document.getElementsByClassName('p-datatable-thead')
            

            if (headers[headers.length - 1]) {
              headers[headers.length - 1].style.display = 'none'
            }
          }, 50)
        },
        numberWithCommas(x) {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatString1(value) {
          
          return value
        },
        formatString(value) {
          if (value) {
            const amount = formatAmount(value)
            return amount !== null ? amount : String(value)
          } else {
            return '0'
          }
        },
        getCustomerStats() {
            this.requesting = true

            this.customerService
                .getCustomerStats(this.$route.params.custid)
                .then(data => {
                    this.requesting = false
                    this.data = data

                    this.setupDataToShow()
                })
                .catch(err => {
                    
                    this.requesting = false
                    
                    // this.$toast.add({
                    //   severity: "error",
                    //   summary: "Error",
                    //   detail: "Error while getting customer history.",
                    //   life: 5000,
                    // })
                    this.$store.dispatch('addErrorMessage', {
                    severity: 'error',
                    content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
                    })
                })
        }
    }
}
</script>

<style scoped lang="scss">
.pad-switch-left 
{
  padding-left: 5px; 
}
.pad-switch-right {
    padding-right: 5px; 
}
</style>